import { Button, Dialog, DialogActions, DialogContent, DialogTitle, List, ListItemButton, ListItemText, Typography } from '@mui/material';
import type { FC } from 'react';
import type { FilterTargetResolution } from '../filterTargetLayerResolver';

type TargetLayerSelectionDialogProps = {
    open: boolean;
    options: FilterTargetResolution[];
    onSelect: (option: FilterTargetResolution) => void;
    onCancel: () => void;
};

const TargetLayerSelectionDialog: FC<TargetLayerSelectionDialogProps> = ({ open, options, onSelect, onCancel }) => {
    return (
        <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth>
            <DialogTitle sx={{ fontSize: '1rem', pb: 1 }}>Choose Target Layer</DialogTitle>
            <DialogContent dividers>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
                    This filter can be applied to one of the following layers. Select one to continue.
                </Typography>
                <List dense sx={{ py: 0 }}>
                    {options.map((option) => (
                        <ListItemButton
                            key={option.layerId}
                            sx={{
                                borderRadius: 1.5,
                                border: '1px solid',
                                borderColor: 'divider',
                                mb: 0.75,
                                '&:last-child': { mb: 0 },
                            }}
                            onClick={() => onSelect(option)}
                        >
                            <ListItemText
                                primary={option.layerName}
                                slotProps={{
                                    primary: { fontSize: '0.75rem', fontWeight: 600 },
                                }}
                            />
                        </ListItemButton>
                    ))}
                </List>
            </DialogContent>
            <DialogActions>
                <Button size="small" onClick={onCancel}>
                    Cancel
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default TargetLayerSelectionDialog;
